import type { RowAction, PreviewRow } from '../types';

export function isActionableRow(action: RowAction): boolean {
  return action === 'CREATE' || action === 'UPDATE' || action === 'LINK';
}

export function actionableRows(rows: PreviewRow[]): PreviewRow[] {
  return rows.filter((r) => isActionableRow(r.action));
}

export function applyTabNameFormat(format: string, date: Date): string {
  const month = date.toLocaleString('en-US', { month: 'long' });
  const year = date.getFullYear().toString();
  return format.replace('MMMM', month).replace('YYYY', year);
}

export interface SelectionCounts {
  create: number;
  update: number;
  link: number;
  total: number;
}

export function countSelected(rows: PreviewRow[], selected: Set<number>): SelectionCounts {
  let create = 0;
  let update = 0;
  let link = 0;
  for (const row of rows) {
    if (!selected.has(row.rowNumber)) continue;
    if (row.action === 'CREATE') create++;
    else if (row.action === 'UPDATE') update++;
    else if (row.action === 'LINK') link++;
  }
  return { create, update, link, total: create + update + link };
}
